<style scoped>
.v-application .subtitle-1 {
  font-size: 14px !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <v-menu offset-y absolute>
    <template v-slot:activator="{ on }">
      <v-btn
        outlined
        color="black"
        elevation="0"
        small
        class="mb-0"
        style="width: 30px; min-width: 35px"
        v-on="on"
      >
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list subheader>
      <v-list-item
        v-for="(item, i) in subMenu"
        :key="i"
        @click="menu_list(item)"
        class="mb-n3 mt-n1 mx-n1"
      >
        <v-list-item-avatar style="width: 20px; min-width: 20px">
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="my-n5 subtitle-1">{{
            item.title
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import quotation_pdf from "../views/pdf/quotation";
import printJS from "print-js";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "TableMenu",
  components: {},
  props: {
    TableData: Object,
    Page: String,
  },
  computed: {
    ...mapGetters({
      GET_QT: "Quotation/GET_QUOTATION",
      GET_BL: "Bill/GET_BILL",
    }),
  },
  data: () => ({
    subMenu: [],
    // subMenu: [
    //   { icon: "mdi-file-document-edit-outline", title: 'แก้ไขเอกสาร' },
    //   { icon: "mdi-printer", title: 'พิมพ์เอกสาร' },
    //   { icon: "mdi-download", title: 'ดาวน์โหลด' },
    //   { icon: "mdi-email-send-outline", title: 'ส่งอีเมล' },
    //   { icon: "mdi-trash-can-outline", title: 'ลบเอกสาร' }
    // ],
  }),
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      EDIT_QT: "Quotation/SET_IS_EDIT",
      SET_QT: "Quotation/SET_ELEMENT",
      SET_ALL_QT: "Quotation/SET_ALL_ELEMENT",
      SET_ALL_QT_PRODUCT: "Quotation/SET_PRODUCT_LIST",
      EDIT_BL: "Bill/SET_IS_EDIT",
      B_SET: "Bill/SET_ELEMENT",
      SET_ALL_BL: "Bill/SET_ALL_ELEMENT",
      B_SPLITING: "Bill/SET_SPLITING",
      B_MERGE: "Bill/MERGE_ALL_ELEMENT",
      B_SET_PRODUCT: "Bill/SET_PRODUCT_LIST",
      SET_STEP: "Drawer/SET_STEP",
    }),
    menu_list(item) {
      if (this.Page == "Quotation") {
        this.qt_menu(item);
      } else if (this.Page == "Bill") {
        this.bill_menu(item);
      } else if (this.Page == "Contract") {
        this.contract_menu(item);
      } else if (this.Page == "Invoice") {
        this.invoice_menu(item);
      }
    },
    invoice_menu(item) {
      //parent is Bill.vue
      if (item.title == "แก้ไขเอกสาร") {
        this.$parent.$parent.$parent.$parent.edit_invoice(this.TableData);
      } else if (item.title == "ลบเอกสาร") {
        this.$parent.$parent.$parent.$parent.remove_invoice(this.TableData);
      } else if (item.title == "ดาวน์โหลด") {
        this.$parent.$parent.$parent.$parent.download_invoice(this.TableData);
      } else if (item.title == "พิมพ์เอกสาร") {
        this.$parent.$parent.$parent.$parent.print_invoice(this.TableData);
      } else if (item.title == "ส่งอีเมล") {
        this.$parent.$parent.$parent.$parent.send_email(this.TableData);
      }
    },
    contract_menu(item) {
      //parent is Bill.vue
      if (item.title == "แก้ไขเอกสาร") {
        this.$parent.$parent.$parent.$parent.edit_contract(this.TableData);
        console.log(this.$parent.$parent.$parent.$parent);
      } else if (item.title == "ลบเอกสาร") {
        this.$parent.$parent.$parent.$parent.remove_contract(this.TableData);
      } else if (item.title == "ดาวน์โหลด") {
        this.$parent.$parent.$parent.$parent.download_contract(this.TableData);
      } else if (item.title == "พิมพ์เอกสาร") {
        this.$parent.$parent.$parent.$parent.print_contract(this.TableData);
      } else if (item.title == "ส่งอีเมล") {
        this.$parent.$parent.$parent.$parent.send_email(this.TableData);
      }
    },
    bill_menu(item) {
      //parent is Bill.vue
      if (item.title == "แก้ไขเอกสาร") {
        this.$parent.$parent.$parent.$parent.edit_bill(this.TableData);
      } else if (item.title == "ลบเอกสาร") {
        this.$parent.$parent.$parent.$parent.remove_bill(this.TableData);
      } else if (item.title == "ดาวน์โหลด") {
        this.$parent.$parent.$parent.$parent.download_bill(this.TableData);
      } else if (item.title == "พิมพ์เอกสาร") {
        this.$parent.$parent.$parent.$parent.print_bill(this.TableData);
      } else if (item.title == "ส่งอีเมล") {
        this.$parent.$parent.$parent.$parent.send_email(this.TableData);
      }
    },
    qt_menu(item) {
      //parent is Quotation.vue
      if (item.title == "แก้ไขเอกสาร") {
        this.$parent.$parent.$parent.$parent.edit_quotation(this.TableData);
      } else if (item.title == "ลบเอกสาร") {
        this.$parent.$parent.$parent.$parent.remove_quotation(this.TableData);
      } else if (item.title == "ดาวน์โหลด") {
        this.$parent.$parent.$parent.$parent.download_quotation(this.TableData);
      } else if (item.title == "ส่งอีเมล") {
        this.$parent.$parent.$parent.$parent.send_email(this.TableData);
      } else if (item.title == "พิมพ์เอกสาร") {
        this.$parent.$parent.$parent.$parent.print_quotation(this.TableData);
      }
    },
  },
  created() {
    if (this.$AppName.name == "เทศบาลนครเชียงใหม่") {
      this.subMenu.push(
        { icon: "mdi-file-document-edit-outline", title: "แก้ไขเอกสาร" },
        { icon: "mdi-printer", title: "พิมพ์เอกสาร" },
        { icon: "mdi-download", title: "ดาวน์โหลด" },
        { icon: "mdi-trash-can-outline", title: "ลบเอกสาร" }
      );
    } else {
      this.subMenu.push(
        { icon: "mdi-file-document-edit-outline", title: "แก้ไขเอกสาร" },
        { icon: "mdi-printer", title: "พิมพ์เอกสาร" },
        { icon: "mdi-download", title: "ดาวน์โหลด" },
        { icon: "mdi-email-send-outline", title: "ส่งอีเมล" },
        { icon: "mdi-trash-can-outline", title: "ลบเอกสาร" }
      );
    }
  },
};
</script>
